// Snapshot of the legacy OMS create-order dropdowns (2026-10-04).
export const warehouseCodes = [
  'PHX3',
  'LIT2',
  'UAZ1',
  'PHX6',
  'XUSH',
  'PHX7',
  'PHX5',
  'GYR2',
  'LAX6',
  'VUKF',
  'XBC1',
  'VUTD',
  'LGB3',
  'SNA9',
  'SNA6',
  'VUGE',
  'HCA6',
  'SBD1',
  'ONT9',
  'XUSV',
  'LGB4',
  'LGB8',
  'XUSJ',
  'SNA4',
  'SNA8',
  'SNA7',
  'ONT4',
  'ONT2',
  'ONT6',
  'ONT8',
  'XUSO',
  'SJC9',
  'UCA7',
  'UCA1',
  'OAK7',
  'UCA8',
  'XUSD',
  'SCK4',
  'OAK6',
  'OAK4',
  'PCA1',
  'SJC7',
  'UCA9',
  'SMF1',
  'DEN2',
  'DEN6',
  'BDL2',
  'PHL7',
  'JAX3',
  'JAX2',
  'MCO2',
  'XUSF',
  'MIA6',
  'TPA1',
  'TPA2',
  'TPA3',
  'ATL9',
  'ATL8',
  'VUGF',
  'CSG1',
  'ATL7',
  'VUKG',
  'MGE3',
  'VUKD',
  'MDW8',
  'ORD6',
  'MDW2',
  'MDW6',
  'PIL1',
  'MDW7',
  'MDW4',
  'STL4',
  'IND1',
  'XUSE',
  'MQJ1',
  'IND9',
  'IND2',
  'IND3',
  'IND5',
  'IND4',
  'PIN1',
  'IND7',
  'VUHB',
  'SDF8',
  'MKC4',
  'MCI7',
  'MKC6',
  'FOE1',
  'SDF6',
  'SDF4',
  'SDF2',
  'IVSA',
  'CVG1',
  'CVG2',
  'CVG7',
  'IVSB',
  'CVG3',
  'SDF1',
  'BOS6',
  'BOS7',
  'BWI2',
  'MDT2',
  'MSP1',
  'UNC2',
  'CLT3',
  'CLT2',
  'EWR7',
  'EWR6',
  'EWR9',
  'ACY2',
  'TEB3',
  'VUKE',
  'TEB6',
  'ABE8',
  'EWR4',
  'LGA9',
  'LAS1',
  'LAS6',
  'RNO4',
  'ALB1',
  'SWF1',
  'CMH1',
  'CMH2',
  'POH1',
  'CMH3',
  'OKC2',
  'UOR1',
  'PHL4',
  'XUSC',
  'PHL6',
  'MDT1',
  'PHL5',
  'ABE3',
  'ABE2',
  'ABE4',
  'AVP1',
  'AVP3',
  'AVP8',
  'RDG1',
  'CAE1',
  'GSP1',
  'BNA2',
  'BNA3',
  'XSP1',
  'CHA2',
  'CHA1',
  'MEM1',
  'DFW6',
  'FTW2',
  'FTW6',
  'DFW9',
  'FTW5',
  'FTW1',
  'VUKH',
  'DAL6',
  'XUSB',
  'DFW7',
  'HOU2',
  'HTX2',
  'HOU3',
  'SAT1',
  'UTX5',
  'SAT2',
  'BWI6',
  'UVA1',
  'BWI4',
  'RIC1',
  'RIC2',
  'BFI6',
  'HWA3',
  'BFI4',
  'UWA1',
  'UWA2',
  'UWA4',
  'BFI3',
  'BFI1',
  'BFI7',
  'GEG1',
  'MKE1',
  'JVL1',
  'YVR1',
  'YYZ1',
  'YYZ2',
  'YYZ3',
  'YYZ4',
  'YYZ6',
  'YVR3',
  'YVR2',
  'YVR4',
  'YYC1-0E0',
  'YYC1',
  'YOW1',
  'YYZ7',
  'YYZ9',
  'YEG1',
  'YXX2',
  'YHM1',
  'YOW3',
  'YOO1',
  'YUL2',
  'FWA4',
  'SMF3',
  'XLX7',
  'DEN8',
  'GYR3',
  'STL3',
  'DET1',
  'SAV3',
  'LAX9',
  'PIT2',
  'TEB9',
  'VGT2',
  'KRB1',
  'SBD2',
  'TTN2',
  'TEB4',
  'DCA6',
  'ILG1',
  'XLX1',
  'BDL6',
  'HGR2',
  'AVP9',
  'CMH6',
  'KRB2',
  'GSO1',
  'ORF2-UPS',
  'DET2',
  'QXY9',
  'IGQ2',
  'FAT2',
  'FTW9',
  'BFL2',
  'HOU8',
  'MEM6',
  'ICT2',
  'OAK3',
  'SLC2',
  'FTW3',
  'KRB4',
  'CMH7',
  'ORF2',
  'SCK1',
  'SCK3',
  'LGB6',
  'LGB9',
  'KRB7',
  'XLX2',
  'SMF6',
  'SMF7',
  'MCE1',
  'AZA4',
  'SLC1',
  'SLC3',
  'OLM1',
  'GEG2',
  'PDX6',
  'PDX7',
  'HOU7',
  'SAT4',
  'SAT6',
  'MDW9',
  'ORD2',
  'DEN7',
  'LFT1',
  'STL6',
  'TPA6',
  'RON4',
  'CHO1',
  'BFI9',
  'AKR1',
  'MDT4',
  'AMA1',
  'YEG2',
  'VGT2-UPS',
  'HSV1',
  'XLX6',
  'MGE1',
  'RIC3',
  'BNA1',
  'SBD3',
  'MEM8',
  'SWF2',
  'DAL2',
  'XLX3',
  'MJQ1',
  'RFD4',
  'SWF2-UPS',
  'AFW1',
  'SCK8',
  'IAH3',
  'IUSJ',
  'PBI2',
  'DTW3',
  'RFD2',
  'RDU2',
  'MCO1',
  'IUSL',
  'RMN3',
  'RMN3-UPS',
  'YXU1',
  'YYC6',
  'YGK1',
  'FTW4',
  'BNA6',
  'HSV2',
  'DFW5s',
  'MEM2',
  'LAN2',
  'RDU4',
  'LBE1',
  'PSC2',
  'ABQ2',
  'IUSP',
  'YYC4',
  'LAN2-UPS',
  'W-LAX1',
  'LAX2',
  'PHX1',
  'W-SMF1',
  'W-ATL3',
  'W-ATL1',
  'KS1',
  'W-NJ3',
  'IND2w',
  'KY1',
  'IND1w',
  'MCO1w',
  'W-PHL2',
  'ATL2',
  'MCI1n',
  'IND2T',
  'IND2N',
  'W-ATL2N',
  'MEM1-S',
  'W-PHL4n',
  'ORD1s',
  'BNA1s',
  'W-MEM1s',
  'W-IND3',
  'CVG1n',
  'NJ3T',
  'TMB8',
  'MCI3',
  'IUSQ',
  'BNA6-UPS',
  'ABQ2-UPS',
  'WBW2',
  'KRB6',
  'LBE1-UPS',
  'RYY2',
  'RYY2-UPS',
  'PBI3',
  'CLT6',
  'TMB8-UPS',
  'HIA1',
  'WBW2-UPS',
  'HGR6',
  'TIKTOK92374',
  'WYT91748',
  'WYT91789',
  'GC91710',
  'GC91710-1',
  'GC92336',
  'GC91710-2',
  'CL91730',
  '4PX90022',
  'TIKTOK91752',
  'YDY91761',
  'SHEIN91744',
  'Wayfair92571',
  'GEU3',
  'MIT2-UPS',
  'LAH3',
  'MIT2',
  'XLG1',
  'HlA1',
  'JOT1',
  'QXY5',
  'MQJ2',
  'IUSF',
  'HLI2-UPS',
  'HLI2',
  'POC3-UPS',
  'POC3',
  'GEU5',
  'GEU2',
  'PSC2-UPS',
  'BWI1',
  'LAX2T',
  'XRI3',
  'CLE3',
  'PCW1',
  'FAR1',
  'MQY1',
  'NJFC',
  'DEN3',
  'JAX1',
  'JAX5',
  '4PX',
  'GCSS-谷仓5仓',
  'GCSS-谷仓',
  'MSP6',
  'IUSR',
  'IUST',
  'TK-NJFC',
  'TK-GAFC',
  '谷仓美东3号仓',
  '谷仓美东15号仓',
  '谷仓美东5号仓',
  '谷仓美东16号仓',
  '谷仓美东18号仓',
  '谷仓美东南1号仓',
  'W-PHL5s',
  'NJ08505',
  'PPO4',
  'POC1',
  'UTX4',
  'AEB8',
  'WPNJ',
  'BER3-14656',
  'CGN1-56330',
  'EDEA-44145',
  'FRA3-36251',
  'LEJ5-07554',
  'WRO2-06126',
  'XDU1-34323',
  'XFR4-31629',
  'XDU2-46147',
  'SCN2-67661',
  'BRE4-28832',
  'POZ1-06126',
  'BCN1-08820',
  'MAD7-45200',
  'MAD9-28804',
  'XMA3-45340',
  'XRE1-43120',
  'RMU1-30156',
  'VLC1-12200',
  'SVQ1-41703',
  'BAT3B-77550',
  'BVA1-80337',
  'LYS1-71311',
  'MRS1-26132',
  'ORY1-45770',
  'ORY1-45772',
  'XOR2-38290',
  'ETZ2-57685',
  'XOR4-80470',
  'XCD1-77380',
  'XFRJ-77176',
  'BGY1-2-24050',
  'XMP2-20074',
  'PSR2-66050',
  'XITF-29100',
  'MXP6-28100',
  'FCO1-02032',
  'MXP3-13100',
  'FCO2-00034',
  'BLQ1-45020',
  'TRN1-10037',
  'BGY1-24050',
  'XMP4-27050',
  'XLI3-27010',
  'POZ1-62-080',
  'WRO2-55-040',
  'SZZ1-72-001',
  'KTW3-44-141',
  'POZ2-66-200',
  'TCY2',
  'TCY1',
  'W-PHL1s',
  'POC2',
  'MOJ1',
  'MQJ1-UPS',
  'PPO4-UPS',
  'DFW2n',
  'HEA2',
  'XEW5',
  'PBI3-UPS',
  'YDC5',
  'XAV3',
  'SCK8-UPS',
  'XPB2',
  'HEA2-UPS',
  'BHX4',
  'BRS1',
  'CWL1',
  'DSA6',
  'EDI4',
  'EMA2',
  'EUK5',
  'GLA1',
  'LBA1',
  'LCY2',
  'LCY3',
  'LTN1',
  'LTN2',
  'LTN4',
  'MME1',
  'MME2',
  'NCL1',
  'XBH3',
  'XLP1',
  'XLT1',
  'XLT2',
  'XPL1',
  'EMA4',
  'NCL2',
  'XBH4',
  'XBH1',
  'LTN9',
  'EUKD',
  'EUKB',
  'EUKC',
  'EUKA',
  'XUKD',
  'IUTI',
  'QXY8',
  'IUTH',
  'XYY1',
  'IUSW',
  'IUTE',
  'MCC1',
  'JFK8',
  'XON1',
  'PSP3',
  'TYS5',
  'AFW5',
  'PSP3-UPS',
  'MEX1',
  'MEX2',
  'MEX3',
  'MEX6',
  'DFW6s',
  'IGQ2-UPS',
  'DTM2',
  'HAJ1',
  'WRO5-02977',
  'LCJ2-04758',
  'WRO5PL',
  'WRO1-04758',
  'XWR3-04758',
  'XPO1-04758',
  'LCJ3-04758',
  'XDR1-04758',
  'XWR1-04758',
  'KTW1-04758',
  'KTW5-04758',
  'DTM1',
  'DTM9',
  'DTM3',
  'KSF7',
  'MHG9',
  'XDEV',
  'XGEB',
  'STR1',
  'BER8',
  'STR2',
  'XDEA',
  'XDU5',
  'DUS2',
  'DUS4',
  'LEJ3',
  'XSC1',
  'HAM2',
  'LEJ1',
  'RLG1',
  'GC3-53881',
  'GC6-53881',
  'GC8-53881',
  'GC5-41199',
  'GC11-53909',
  'GC10-53881',
  'Orange-55450',
  '4PX-55459',
  '4PX-65462',
  '4PX-28197',
  'Winit-28197',
  'CDG7',
  'LIL1',
  'LIL8',
  'XOS1',
  'XOR1',
  'XVA1',
  'XFRN',
  'CD-77550',
  'CD-77230',
  'CD-33610',
  '4PX-77230',
  '4PX-95310',
  'GC-60440',
  'GC-95500',
  '4px-66340',
  '海外仓-69100',
  'TRN3',
  'BLQ8',
  'MXP5',
  'ZAZ1',
  'BCN8',
  'MAD6',
  'BHX4-CV59DQ',
  'BHX4-CV59FA',
  'BHX4-CV59PF',
  'LBA4',
  'BHX8',
  'LBA8',
  'BHX2',
  'BHX7',
  'XBH7',
  'LTN7',
  'XBH5',
  'EMA3',
  'XDS1',
  'BHX5',
  'MAN4',
  'XUKS',
  'LBA2',
  'DSA7',
  'BRS2',
  'BHX1',
  'BHX3',
  'EMA1',
  'XBH2',
  'XUKA',
  'LPL2',
  'XBH9',
  'MAN1',
  'MAN2',
  'MAN3',
  'GC-WR40AD',
  'GC-WR40SZ',
  'GC-WS118AA',
  'GC-WS111SL',
  'GC-ST150SH',
  'Winit-B782FG',
  'Winit-LE38DX',
  'Orange-B67AP',
  'Orange-LE194DB',
  'Orange-CV211PR',
  '4PX-LU54RZ',
  'TOL3',
  'TOL3-UPS',
  '美西一件代发仓库1',
  '美西一件代发仓库2',
  '美西一件代发仓库3',
  '美西一件代发仓库4',
  '美东一件代发仓库1',
  '美东一件代发仓库2',
  'TEST',
  'QZZ7',
  'TESTFBA',
  'MCI4',
  'MCI4-UPS',
  'W-PHL2n',
  'BJC1',
  'SMD1',
  'XFK1',
  'TIKTOK-HOU3',
  'TIKTOK-HOU1',
  'TIKTOK-(IL60188)',
  'TIKTOK-HOU2',
  'NEWEGG-NJ08837',
  'Wayfair-NJ08512',
  'XCD2',
  'ITX3',
  'IMO1',
  'CDG8',
  'IGA3',
  'IMS1',
  'IMI1',
  'XFR9',
  'IUTJ',
  'IUTL',
  'IWA6',
  'INC1',
  'IAZ1',
  'AQB2',
  'GEU2-UPS',
  '美东一件代发仓库3',
  'POC2-UPS',
  'MQY2',
  'IEUB',
  'IPA1',
  'W-SMF2',
  'XLDA',
  'IEUA',
  'XPLC',
  'LBA3',
  'EMA5',
  'LCY1',
  'XPH1'
]

export const destinationCountries = [
  {
    value: 'US',
    label: 'US 美国 UNITED STATES OF AMERICA'
  },
  {
    value: 'AT',
    label: 'AT 奥地利 Austria'
  },
  {
    value: 'AU',
    label: 'AU 澳大利亚 Australia'
  },
  {
    value: 'BE',
    label: 'BE 比利时 Belgium'
  },
  {
    value: 'BG',
    label: 'BG 保加利亚 Bulgaria'
  },
  {
    value: 'CA',
    label: 'CA 加拿大 CANADA'
  },
  {
    value: 'CN',
    label: 'CN 中国 CHINA, PEOPLES REPUBLIC'
  },
  {
    value: 'CZ',
    label: 'CZ 捷克-捷克共和国 Czech Republic'
  },
  {
    value: 'DE',
    label: 'DE 德国 Germany'
  },
  {
    value: 'DK',
    label: 'DK 丹麦 Denmark'
  },
  {
    value: 'EE',
    label: 'EE 爱沙尼亚 Estonia'
  },
  {
    value: 'ES',
    label: 'ES 西班牙 Spain'
  },
  {
    value: 'FI',
    label: 'FI 芬兰 Finland'
  },
  {
    value: 'FR',
    label: 'FR 法国 France'
  },
  {
    value: 'GB',
    label: 'GB 英国 Great Britain'
  },
  {
    value: 'GR',
    label: 'GR 希腊 Greece'
  },
  {
    value: 'HR',
    label: 'HR 克罗地亚 Croatia'
  },
  {
    value: 'HU',
    label: 'HU 匈牙利 Hungary'
  },
  {
    value: 'IE',
    label: 'IE 爱尔兰 IRELAND'
  },
  {
    value: 'IT',
    label: 'IT 意大利 Italy'
  },
  {
    value: 'LT',
    label: 'LT 立陶宛 Lithuania'
  },
  {
    value: 'LU',
    label: 'LU 卢森堡 Luxembourg'
  },
  {
    value: 'LV',
    label: 'LV 拉脱维亚 Latvia'
  },
  {
    value: 'MX',
    label: 'MX 墨西哥 Mexico'
  },
  {
    value: 'NL',
    label: 'NL 荷兰 Netherlands'
  },
  {
    value: 'PL',
    label: 'PL 波兰 Poland'
  },
  {
    value: 'PT',
    label: 'PT 葡萄牙 Portugal'
  },
  {
    value: 'SE',
    label: 'SE 瑞典 Sweden'
  },
  {
    value: 'SI',
    label: 'SI 斯洛文尼亚 Slovenia'
  },
  {
    value: 'SK',
    label: 'SK 斯洛伐克 Slovakia'
  }
]

export const shippingAreas = [
  {
    value: '3',
    label: '美东'
  },
  {
    value: '1',
    label: '美西'
  },
  {
    value: '2',
    label: '美中'
  },
  {
    value: '4',
    label: '加西'
  },
  {
    value: '5',
    label: '加东'
  },
  {
    value: '6',
    label: '美西加拿大'
  },
  {
    value: '7',
    label: '其他'
  },
  {
    value: '8',
    label: 'US EXPORT'
  }
]

// Product groups observed in the legacy OMS create-order dropdown for the
// configured customer account.  Keep this list in the same order and with the
// same membership as the legacy `bas_lms_cust_hubin` tree.  The provider
// catalogue contains many historical/other-region products; including those
// here makes the new order form show products that the legacy form never
// offered for the selected shipping area.
export const shippingAreaProductCodes = {
  // 美西：FedEx 8 + GOFO 1 + UNIUNI 1 + UPS 6 + USPS 1 = 17
  1: ['CE', 'AH', 'FH', 'RW', 'SWS', 'WFC', 'SWE', 'FWL', 'US-GOFO-Parcel-LAX-M', 'ULAX', 'BDW', 'AJ', 'AM', 'UWH', 'WHC', 'UWK', 'WPC'],
  // 美中：FedEx 4 + GOFO 1 + UNIUNI 1 + UPS 2 + USPS 1 = 9
  2: ['A5', 'FCH', 'CFC', 'SCE', 'US-GOFO-Parcel-ORD-M', 'UDFW', 'BDM', 'ACM', 'CPC'],
  // 美东：FedEx 4 + GOFO 1 + UNIUNI 1 + UPS 2 + USPS 1 = 9
  3: ['AQ', 'SES', 'EFC', 'SEE', 'US-GOFO-Parcel-JFK-M', 'UJFK', 'BDE', 'AEM', 'EPC'],
  4: [],
  5: [],
  6: [],
  7: ['FHZ', 'USPS-ZDY'],
  8: []
}

// The legacy tree uses customer-facing service names rather than the shorter
// names returned by the catalogue synchronisation endpoint.  Keep the
// presentation mapping in the UI layer: the raw provider name remains stored
// for billing/audit purposes, while the order form looks the same as the
// legacy OMS screen.
export const legacyProductDisplayNames = Object.freeze({
  CE: '美西FEDEX GROUND/MTW-CE',
  AH: '美西FEDEX GROUND/MTW-A',
  FH: '美西FEDEX GROUND/MTW-H',
  RW: '美西FEDEX GROUND/MTW-E',
  SWS: '美西FedexSmartPost-S',
  WFC: '美西 FedEx Ground-C',
  SWE: '美西 FedEx SmartPost-E',
  FWL: '美西FEDEX GROUND MTW-L',
  'US-GOFO-Parcel-LAX-M': 'US-GOFO-Parcel-LAX-M',
  ULAX: 'UNIUNI-LAX',
  BDW: '美西UPS GROUND-BD',
  AJ: '美西UPS HWT-B',
  AM: '美西UPS GROUND-A',
  UWH: '美西UPS GROUND-H',
  WHC: '美西 UPS HWT-C',
  UWK: '美西UPS GROUND-K',
  WPC: '美西 USPS-C',
  A5: '美中FEDEX GROUND/MTW-A',
  FCH: '美中FEDEX GROUND/MTW-H',
  CFC: '美中 FedEx Ground-C',
  SCE: '美中 FedEx SmartPost-E',
  'US-GOFO-Parcel-ORD-M': 'US-GOFO-Parcel-ORD-M',
  UDFW: 'UNIUNI-DFW',
  BDM: '美中UPS GROUND-BD',
  ACM: '美中UPS GROUND-A',
  CPC: '美中 USPS-C',
  AQ: '美东FEDEX GROUND/MTW-A',
  SES: '美东FedexSmartPost-S',
  EFC: '美东 FedEx Ground-C',
  SEE: '美东 FedEx SmartPost-E',
  'US-GOFO-Parcel-JFK-M': 'US-GOFO-Parcel-JFK-M',
  UJFK: 'UNIUNI-JFK',
  BDE: '美东UPS GROUND-BD',
  AEM: '美东UPS GROUND-A',
  EPC: '美东 USPS-C'
})

export const legacyProductCategories = Object.freeze({
  CE: 'FedEx',
  AH: 'FedEx',
  FH: 'FedEx',
  RW: 'FedEx',
  SWS: 'FedEx',
  WFC: 'FedEx',
  SWE: 'FedEx',
  FWL: 'FedEx',
  'US-GOFO-Parcel-LAX-M': 'GOFO',
  ULAX: 'UNIUNI',
  BDW: 'UPS',
  AJ: 'UPS',
  AM: 'UPS',
  UWH: 'UPS',
  WHC: 'UPS',
  UWK: 'UPS',
  WPC: 'USPS',
  A5: 'FedEx',
  FCH: 'FedEx',
  CFC: 'FedEx',
  SCE: 'FedEx',
  'US-GOFO-Parcel-ORD-M': 'GOFO',
  UDFW: 'UNIUNI',
  BDM: 'UPS',
  ACM: 'UPS',
  CPC: 'USPS',
  AQ: 'FedEx',
  SES: 'FedEx',
  EFC: 'FedEx',
  SEE: 'FedEx',
  'US-GOFO-Parcel-JFK-M': 'GOFO',
  UJFK: 'UNIUNI',
  BDE: 'UPS',
  AEM: 'UPS',
  EPC: 'USPS'
})

export const legacyProductName = product => {
  const code = product && String(product.code == null ? '' : product.code)
  return legacyProductDisplayNames[code] || (product && product.name) || code
}

export const legacyProductCategory = product => {
  const code = product && String(product.code == null ? '' : product.code)
  return (product && product.productType) || legacyProductCategories[code] || (product && product.category) || '其他产品'
}

export const densityOptions = [
  '50',
  '55',
  '60',
  '65',
  '70',
  '77.5',
  '85',
  '92.5',
  '100',
  '110',
  '125',
  '150',
  '175',
  '200',
  '250',
  '300',
  '400',
  '500'
]
